import { PlazaStatMissionPage } from "./../plaza-stat-mission/plaza-stat-mission";
import { TranslateService } from "@ngx-translate/core";
import { ServiceProvider } from "./../../providers/service/service";
import { Http, RequestOptions, Headers } from "@angular/http";
import { Storage } from "@ionic/storage";
import { HomePage } from "./../home/home";
import { PlazaStatShopperPage } from "./../plaza-stat-shopper/plaza-stat-shopper";
import { PlazaStatMerchantPage } from "./../plaza-stat-merchant/plaza-stat-merchant";
import { ViewHeaderPage } from "./../view-header/view-header";
import { PlazaCashflowPage } from "./../plaza-cashflow/plaza-cashflow";
import { PlazaProfitPage } from "./../plaza-profit/plaza-profit";
import { Component } from "@angular/core";
import { IonicPage, NavController, LoadingController } from "ionic-angular";
import { VideoTutorialModalPage } from "../video-tutorial-modal/video-tutorial-modal";
// import {
//   StreamingMedia,
//   StreamingVideoOptions,
// } from "@ionic-native/streaming-media";

@IonicPage()
@Component({
  selector: "page-plaza-result",
  templateUrl: "plaza-result.html",
})
export class PlazaResultPage {
  // stat_shopperBath: any;
  lang = "";
  stat_shopperAmount: any;
  shoppers = [{ shopper_id: "", shopper_name: "", total: "", total_sales: "" }];
  shoppers_total = 0;
  stat_merchantPrice: any;
  stat_merchantAmount: any;
  stat_merchantAccumulateAmount: any;
  stat_merchantAccumulateBath: any;
  round = 1;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    public translateService: TranslateService,
    private loadingCtrl: LoadingController // private streamingMedia: StreamingMedia
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("roundGame").then((round) => {
      this.storage.get("language").then((lang) => {
        this.lang = lang;
        this.round = round;
      });
    });

    this.storage.get("token").then((token) => {
      //shopper
      var link = this.services.URLPlazaStatShopper;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.shoppers = data.shoppers;
            this.shoppers_total = data.total;
            this.stat_shopperAmount = [];

            var shop_total = data.shoppers.length;
            for (let i = 0; i < shop_total; i++) {
              // this.stat_shopperBath.push( [this.shoppers[i].shopper_name, parseInt(this.shoppers[i].total_sales)] );

              this.stat_shopperAmount.push([
                data.shoppers[i].shopper_name,
                parseInt(data.shoppers[i].total) < 0
                  ? parseInt(data.shoppers[i].total) * -1
                  : parseInt(data.shoppers[i].total),
              ]);
            }
            // console.log("stat_shopperAmount=", this.stat_shopperAmount);

            //merchants price
            var link2 = this.services.URLPlazaStatMerchant;

            this.http
              .get(link2, requestOptions)
              .map((res) => res.json())
              .subscribe(
                (data2) => {
                  this.stat_merchantPrice = [];

                  var merchant_total = data2.merchants.length;
                  for (let i = 0; i < merchant_total; i++) {
                    this.stat_merchantPrice.push([
                      data2.merchants[i].merchant_name,
                      parseFloat(data2.merchants[i].total_sales),
                    ]);
                  }

                  // console.log("stat_merchantPrice=", this.stat_merchantPrice);

                  //merchant amount
                  var link3 = this.services.URLPlazaShopperTraffic;

                  this.http
                    .get(link3, requestOptions)
                    .map((res) => res.json())
                    .subscribe(
                      (data3) => {
                        this.stat_merchantAmount = [];
                        this.stat_merchantAmount.push([
                          "Element",
                          "Amount",
                          { role: "annotation" },
                          { role: "style" },
                        ]);
                        let color = "";
                        var merchant_total = data3.merchants.length;
                        for (let i = 0; i < merchant_total; i++) {
                          if (i == 0) {
                            color = "#3d4c9f";
                          } else if (i == 1) {
                            color = "#3d8a43";
                          } else if (i == 2) {
                            color = "#408bca";
                          } else if (i == 3) {
                            color = "#a4d334";
                          } else if (i == 4) {
                            color = "#f796f7";
                          } else if (i == 4) {
                            color = "#ff924e";
                          }
                          this.stat_merchantAmount.push([
                            data3.merchants[i].merchant_name,
                            parseFloat(data3.merchants[i].total_shoppers),
                            parseFloat(data3.merchants[i].total_shoppers),
                            color,
                          ]);
                        }

                        // console.log("stat_merchantAmount=", this.stat_merchantAmount);

                        // merchant accumulate amount
                        var link4 = this.services.URLPlazaShopperAccumulate;
                        this.http
                          .get(link4, requestOptions)
                          .map((res) => res.json())
                          .subscribe(
                            (data) => {
                              this.stat_merchantAccumulateAmount = [];

                              var total = data.length;
                              if (total == 1) {
                                this.stat_merchantAccumulateAmount.push([
                                  "MERCHANT",
                                  "ROUND 1",
                                  { role: "annotation" },
                                ]);
                                var unit_total1 = data[0].merchants.length;
                                for (let j = 0; j < unit_total1; j++) {
                                  let m = j + 1;
                                  this.stat_merchantAccumulateAmount.push([
                                    "MERCHANT " + m,
                                    parseInt(
                                      data[0].merchants[j].total_shoppers
                                    ),
                                    parseInt(
                                      data[0].merchants[j].total_shoppers
                                    ),
                                  ]);
                                }
                                // console.log("stat_merchantAccumulateAmount=", this.stat_merchantAccumulateAmount);
                              } else if (total == 2) {
                                this.stat_merchantAccumulateAmount.push([
                                  "MERCHANT",
                                  "ROUND 1",
                                  { role: "annotation" },
                                  "ROUND 2",
                                  { role: "annotation" },
                                ]);
                                var unit_total2 = data[0].merchants.length;
                                for (let j = 0; j < unit_total2; j++) {
                                  let m = j + 1;
                                  this.stat_merchantAccumulateAmount.push([
                                    "MERCHANT " + m,
                                    parseInt(
                                      data[0].merchants[j].total_shoppers
                                    ),
                                    parseInt(
                                      data[0].merchants[j].total_shoppers
                                    ),
                                    parseInt(
                                      data[1].merchants[j].total_shoppers
                                    ),
                                    parseInt(
                                      data[1].merchants[j].total_shoppers
                                    ),
                                  ]);
                                }
                                // console.log("stat_merchantAccumulateAmount=", this.stat_merchantAccumulateAmount);
                              } else if (total == 3) {
                                this.stat_merchantAccumulateAmount.push([
                                  "MERCHANT",
                                  "ROUND 1",
                                  { role: "annotation" },
                                  "ROUND 2",
                                  { role: "annotation" },
                                  "MERCHANT 3",
                                  { role: "annotation" },
                                ]);
                                var unit_total3 = data[0].merchants.length;
                                for (let j = 0; j < unit_total3; j++) {
                                  let m = j + 1;
                                  this.stat_merchantAccumulateAmount.push([
                                    "MERCHANT " + m,
                                    parseInt(
                                      data[0].merchants[j].total_shoppers
                                    ),
                                    parseInt(
                                      data[0].merchants[j].total_shoppers
                                    ),
                                    parseInt(
                                      data[1].merchants[j].total_shoppers
                                    ),
                                    parseInt(
                                      data[1].merchants[j].total_shoppers
                                    ),
                                    parseInt(
                                      data[2].merchants[j].total_shoppers
                                    ),
                                    parseInt(
                                      data[2].merchants[j].total_shoppers
                                    ),
                                  ]);
                                }
                                // console.log("stat_merchantAccumulateAmount=", this.stat_merchantAccumulateAmount);
                              }

                              // merchant accumulate bath
                              var link5 = this.services.URLPlazaSalesAccumulate;
                              this.http
                                .get(link5, requestOptions)
                                .map((res) => res.json())
                                .subscribe(
                                  (data) => {
                                    this.stat_merchantAccumulateBath = [];

                                    var total = data.length;
                                    if (total == 1) {
                                      this.stat_merchantAccumulateBath.push([
                                        "MERCHANT",
                                        "ROUND 1",
                                        { role: "annotation" },
                                      ]);
                                      var unit_total1 =
                                        data[0].merchants.length;
                                      for (let j = 0; j < unit_total1; j++) {
                                        let m = j + 1;
                                        this.stat_merchantAccumulateBath.push([
                                          "MERCHANT " + m,
                                          parseInt(
                                            data[0].merchants[j].total_sales
                                          ),
                                          parseInt(
                                            data[0].merchants[j].total_sales
                                          ),
                                        ]);
                                      }
                                      // console.log("stat_merchantAccumulateBath=", this.stat_merchantAccumulateBath);
                                    } else if (total == 2) {
                                      this.stat_merchantAccumulateBath.push([
                                        "MERCHANT",
                                        "ROUND 1",
                                        { role: "annotation" },
                                        "ROUND 2",
                                        { role: "annotation" },
                                      ]);
                                      var unit_total2 =
                                        data[0].merchants.length;
                                      for (let j = 0; j < unit_total2; j++) {
                                        let m = j + 1;
                                        this.stat_merchantAccumulateBath.push([
                                          "MERCHANT " + m,
                                          parseInt(
                                            data[0].merchants[j].total_sales
                                          ),
                                          parseInt(
                                            data[0].merchants[j].total_sales
                                          ),
                                          parseInt(
                                            data[1].merchants[j].total_sales
                                          ),
                                          parseInt(
                                            data[1].merchants[j].total_sales
                                          ),
                                        ]);
                                      }
                                      // console.log("stat_merchantAccumulateBath=", this.stat_merchantAccumulateBath);
                                    } else if (total == 3) {
                                      this.stat_merchantAccumulateBath.push([
                                        "MERCHANT",
                                        "ROUND 1",
                                        { role: "annotation" },
                                        "ROUND 2",
                                        { role: "annotation" },
                                        "MERCHANT 3",
                                        { role: "annotation" },
                                      ]);
                                      var unit_total3 =
                                        data[0].merchants.length;
                                      for (let j = 0; j < unit_total3; j++) {
                                        let m = j + 1;
                                        this.stat_merchantAccumulateBath.push([
                                          "MERCHANT " + m,
                                          parseInt(
                                            data[0].merchants[j].total_sales
                                          ),
                                          parseInt(
                                            data[0].merchants[j].total_sales
                                          ),
                                          parseInt(
                                            data[1].merchants[j].total_sales
                                          ),
                                          parseInt(
                                            data[1].merchants[j].total_sales
                                          ),
                                          parseInt(
                                            data[2].merchants[j].total_sales
                                          ),
                                          parseInt(
                                            data[2].merchants[j].total_sales
                                          ),
                                        ]);
                                      }
                                      // console.log("stat_merchantAccumulateBath=", this.stat_merchantAccumulateBath);
                                    }

                                    loader.dismiss();
                                  },
                                  (error) => {
                                    var response = JSON.parse(error._body);
                                    this.translateService
                                      .get(response.message)
                                      .subscribe((value) => {
                                        this.services.presentToast(value);
                                      });
                                  }
                                );
                            },
                            (error) => {
                              var response = JSON.parse(error._body);
                              this.translateService
                                .get(response.message)
                                .subscribe((value) => {
                                  this.services.presentToast(value);
                                });
                            }
                          );
                      },
                      (error) => {
                        var response = JSON.parse(error._body);
                        this.translateService
                          .get(response.message)
                          .subscribe((value) => {
                            this.services.presentToast(value);
                          });
                      }
                    );
                },
                (error) => {
                  var response = JSON.parse(error._body);
                  this.translateService
                    .get(response.message)
                    .subscribe((value) => {
                      this.services.presentToast(value);
                    });
                }
              );
          },
          (error) => {
            var response = JSON.parse(error._body);
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    }); //close token
  }

  profit() {
    this.navCtrl.push(PlazaProfitPage);
  }

  cashflow() {
    this.navCtrl.push(PlazaCashflowPage);
  }

  merchantStat() {
    this.navCtrl.push(PlazaStatMerchantPage, {
      stat_merchantPrice: this.stat_merchantPrice,
      stat_merchantAmount: this.stat_merchantAmount,
      stat_merchantAccumulateAmount: this.stat_merchantAccumulateAmount,
      stat_merchantAccumulateBath: this.stat_merchantAccumulateBath,
    });
  }

  shopperStat() {
    this.navCtrl.push(PlazaStatShopperPage, {
      stat_shopperAmount: this.stat_shopperAmount,
      shoppers: this.shoppers,
      shoppers_total: this.shoppers_total,
    });
  }

  backPage() {
    this.navCtrl.setRoot(HomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(HomePage);
  }

  mission() {
    this.navCtrl.push(PlazaStatMissionPage);
  }

  showVideo() {
    // let options: StreamingVideoOptions = {
    //   successCallback: () => {
    //     console.log("Video played");
    //   },
    //   errorCallback: (e) => {
    //     console.log("Error streaming");
    //   },
    //   orientation: "landscape",
    //   shouldAutoClose: true,
    //   controls: true,
    // };

    if (this.lang == "en-Us") {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 12,
          vdo: video[12].video_url,
        });
        // this.streamingMedia.playVideo(video[12].video_url, options);
      });
    } else {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 13,
          vdo: video[13].video_url,
        });
        // this.streamingMedia.playVideo(video[13].video_url, options);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-result/plaza-result.ts